import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const BrowseCollectionByAppHeader = declareString(
  "promptLibrary.browseCollectionByAppHeader",
  {
    text: "Browse prompts by app",
    comment: `Header that appears above collection tiles on the home page. Clicking on collection tile will navigate user to L2 page with prompts filtered by selected app.`,
  }
);

export const BrowseCollectionByTaskHeader = declareString(
  "promptLibrary.browseCollectionByTaskHeader",
  {
    text: "Browse prompts by task",
    comment: `Header that appears above collection tiles on the home page. Clicking on collection tile will navigate user to L2 page with prompts filtered by selected task.`,
  }
);

export const RecentlyLikedPromptSectionHeader = declareString(
  "promptLibrary.recentlyLikedPromptSectionHeader",
  {
    text: "Recently liked prompts",
    comment: `Header that appears above recently liked prompt cards on the home page`,
  }
);

export const MicrosoftPromptSectionHeader = declareString(
  "promptLibrary.microsoftPromptSectionHeader",
  {
    text: "Discover prompts created by Microsoft",
    comment: `Header that appears above the Microsoft prompt section on the home page`,
  }
);

export const TenantPromptSectionHeader = declareString(
  "promptLibrary.tenantPromptSectionHeader",
  {
    text: "Discover prompts created by your organization",
    comment: `Header that appears above the organization prompt section on the home page`,
  }
);

export const TenantPromptFromTenantSectionHeader =
  declareStringWithPlaceholders(
    "promptLibrary.tenantPromptFromTenantSectionHeader",
    {
      text: ({ tenantName }: { tenantName: string }) =>
        `Discover prompts created by ${tenantName}`,
      placeholders: {
        tenantName: "Name of the organization / tenant.",
      },
      comment: `Header that appears above the organization prompt section on the home page`,
    }
  );
